import Layout from "../Frames/Layout"
import { Stack } from "@mui/material"
import Enrollments from "./Enrollments"
import Packs from "../Packs/components/Packs"
import { Masterclass } from "./Masterclass"

export default function Dashboard(){

    return <Layout tab="enrollments" menu="main">

        <Stack spacing={4} sx={{mt: 3}}>

            <Enrollments />

            <Packs />

            <Masterclass />

        </Stack>

    </Layout>
}


